// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"HeroAbout_sectionContainer__RUGCU","canvas":"HeroAbout_canvas__SRro4","textContainer":"HeroAbout_textContainer__HC8il"};